import { ReactComponent as ConfirmIcon } from "assets/images/big-tik.svg";
import { ReactComponent as CircleClose } from "assets/images/circle_close.svg";
import { Button } from "components";
import React from "react";
import { Button as ButtonComponent, Modal } from "react-bootstrap";
import { NotificationModalProps } from "./NotificationModal.props";

const NotificationModal = React.memo<NotificationModalProps>(
    ({
        showModal,
        text,
        handleHideModal,
        handleCloseButton,
        handleConfirm,
    }) => {
        return (
            <Modal
                show={showModal}
                onHide={handleHideModal}
                className="rtl confirm-submit-order"
                aria-labelledby="NotificationModal"
                centered
                data-testid="NotificationModal"
            >
                <Modal.Body data-testid="NotificationModal__body">
                    <ButtonComponent
                        className="close-btn"
                        variant="secondary"
                        onClick={handleCloseButton}
                        data-testid="NotificationModal__closebutton"
                    >
                        <CircleClose />
                    </ButtonComponent>
                    <ConfirmIcon className="confirm-logo" />
                    {text}
                </Modal.Body>
                <Button
                    btnText="متوجه شدم"
                    className="solid is-pink pushLeft"
                    handleClick={handleConfirm}
                />
            </Modal>
        );
    }
);

export default NotificationModal;
